import React, { useEffect, useState } from "react";
import styled from "styled-components";

export const StyledGiftCardButton = styled.div`
    left: 0;
    right: 0;
    bottom: 10%;
    z-index: 998;

    display: flex;
    width: auto;
    margin: 20px auto 40px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 999px;
    background-color: hsla(0, 0%, 100%, 0.1);

    backdrop-filter: blur(16px);
    width: fit-content;
    border: 1px solid #1a4fa2;
    transition: 0.3s;

    &:hover {
        background-color: hsla(0, 0%, 100%, 0.2);
    }

    &:before {
        content: "";
        box-sizing: border-box;
        position: absolute;
        z-index: 1;
        top: -1px;
        left: 0;
        right: 0;
        bottom: -1px;
        border-radius: 50px;
        padding: 1px;
        background: rgb(48, 174, 255);
        background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 10.99%,
            rgba(255, 255, 255, 0.32) 26%,
            rgba(255, 255, 255, 0) 37%
        );
        background-size: 400%;
        -webkit-mask: linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
        animation: steam 20s linear infinite;
    }

    @keyframes steam {
        0% {
            background-position: 0 0;
        }
        50% {
            background-position: 400% 0;
        }
        100% {
            background-position: 0 0;
        }
    }

    a {
        font-weight: 500;
        font-size: 18px;
        letter-spacing: 0.7px;
        color: white;
        position: relative;
        z-index: 4;
        padding: 15px 45px;

        background: linear-gradient(
            180deg,
            #ffffff 0%,
            rgba(255, 255, 255, 0.6) 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
`;

const GiftcardButton = ({ text }) => {

    return (
        <StyledGiftCardButton /* hide={hideButton} */>
            <a href="https://buenbit.onelink.me/A1PW/55a3c7e9">{text}</a>
        </StyledGiftCardButton>
    );
};

export default GiftcardButton;
